/* Batterijenvoordeel: rustig onthullen van blokken bij het scrollen.
   Faalt stil: zonder JavaScript of zonder IntersectionObserver blijft alles zichtbaar,
   en wie 'minder beweging' heeft ingesteld krijgt geen animatie. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var selector = [
    '.bv .sectie-kop', '.bv .offerte-kaart', '.bv .stap', '.bv .bat-kaart', '.bv .klasse-kop',
    '.bv .rekensom-item', '.bv .faq-item', '.bv .uitleg-kaart', '.bv .urgentie-inner',
    '.bv .calc-form', '.bv .calc-uitkomst', '.bv .calc-mail', '.bv .scenario-uitleg',
    '.bv .wf-vragen', '.bv .wf-kaart', '.bv .wf-stappen', '.bv .vgl-wrap'
  ].join(', ');

  function start() {
    var elementen = document.querySelectorAll(selector);
    if (!elementen.length) return;
    var kijker = new IntersectionObserver(function (items) {
      items.forEach(function (item) {
        if (item.isIntersecting) {
          var el = item.target;
          el.classList.add('bv-onthuld');
          kijker.unobserve(el);
          /* na afloop opruimen, zodat hover-animaties hun eigen snelheid terugkrijgen */
          setTimeout(function () {
            el.classList.remove('bv-onthul', 'bv-onthuld');
            el.style.transitionDelay = '';
          }, 1000);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -36px 0px' });

    var teller = 0;
    elementen.forEach(function (el) {
      el.classList.add('bv-onthul');
      /* kleine trapsgewijze vertraging per blok binnen dezelfde rij */
      el.style.transitionDelay = ((teller % 4) * 70) + 'ms';
      teller++;
      kijker.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
